import React, { CSSProperties, PureComponent, ReactElement } from 'react';

import { MapAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, number, string } from '@philips-emr/tws-core/lib/component/prop-types';

import { Loader } from '..';

import './map.scss';

export interface MapProperties {
  height: number;
  loading?: boolean;
  providerUrl: string;
  visible: boolean;
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: MapAPI })
class Map extends PureComponent<MapProperties> {

  static propTypes = {
    height: number,
    loading: bool,
    providerUrl: string,
    visible: bool,
  };

  static defaultProps = {
    height: 200,
    providerUrl: 'https://www.google.com/maps/embed/v1/place?q=place_id=ChIJ3xaSbEkZ35QRx26m5q62zKI&key=AIzaSyCnMCTUecQ1iAph2t_QqpQilHVjuBcyiSg',
    visible: true,
  };

  getFrameStyle(): CSSProperties {
    const { height } = this.props;

    return {
      border: 0,
      height: `${height}px`,
      width: '100%',
    };
  }

  render(): ReactElement | null {
    const { loading, providerUrl, visible } = this.props;

    if (!visible) {
      return null;
    }

    return (
      <div className="c-map">
        {loading
          ? <Loader className="c-map__loader" size={64} />
          : <iframe frameBorder="0" src={providerUrl} style={this.getFrameStyle()} />}
      </div>
    );
  }
}

export default Map;
